function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="currentColor" viewBox="0 0 16 17" {...props}><path d="M.543 2.283l13.724 13.724a.843.843 0 1 0 1.193-1.194L1.736 1.09A.843.843 0 1 0 .543 2.283zm13.724-1.194L.543 14.813a.843.843 0 1 0 1.193 1.194L15.46 2.283a.843.843 0 1 0-1.193-1.194z" /></svg>;
});